"use client";
import dynamic from "next/dynamic";

/**
 * SocialLogin component dynamically imported with SSR disabled.
 *
 * This is done to prevent hydration issues due to the client-side feature
 * flags used within the SocialLogin component.
 *
 * This may be removed in the future when all social login providers are fully supported.
 */
export const SocialLogin = dynamic(
	() => import("./SocialLogin").then(mod => mod.SocialLogin),
	{ ssr: false }
);
